<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><span aria-label="ii" class="page" epub:type="pagebreak" id="pii" role="doc-pagebreak"></span><span aria-label="iii" class="page" epub:type="pagebreak" id="piii" role="doc-pagebreak"></span><img alt="" height="400" src="images/title-400.jpg" width="406"/></h1>
<p class="bkpub">The University of Chicago Press</p>
<p class="bkpub1">Chicago and London</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-mitchell-0003.vue?5c0695ad